import { PretaxClaimStatus, CombinedClaimStatus } from 'constants/claims';
import { startCase } from 'lodash';
import { DefaultTheme } from 'styled-components';

import { convertToCurrency } from '@joinforma/ui/helpers/currency';
import { ClaimStatus } from '../components/ClaimDetailPretaxClaim/types';

export const claimStatusColor = ({
  status,
  theme: {
    colors: {
      icon: { negative, warning, positive },
    },
  },
}: {
  status: ClaimStatus;
  theme: DefaultTheme;
}) => {
  switch (status) {
    case CombinedClaimStatus.IN_PROGRESS:
    case CombinedClaimStatus.COMPLETED:
    case CombinedClaimStatus.APPROVED:
    case CombinedClaimStatus.REIMBURSED:
      return positive;
    case CombinedClaimStatus.PENDING:
    case CombinedClaimStatus.OVERPAID:
      return warning;
    case CombinedClaimStatus.NEEDS_RECEIPT:
    case CombinedClaimStatus.REJECTED:
      return negative;
    default:
      return warning;
  }
};

export const alegeusStatusToTwicStatus = ({ status }: $TSFixMe) => {
  switch (status.toLowerCase()) {
    case PretaxClaimStatus.APPROVED:
    case PretaxClaimStatus.PARTIALLY_APPROVED:
    case PretaxClaimStatus.ACTIVE:
    case PretaxClaimStatus.COMPLETED:
    case PretaxClaimStatus.CONFIRMED:
    case PretaxClaimStatus.FULFILLED:
    case PretaxClaimStatus.SHIPPED:
    case PretaxClaimStatus.PAID:
    case PretaxClaimStatus.PARTIALLY_PAID:
      return CombinedClaimStatus.APPROVED;
    case PretaxClaimStatus.IN_PROGRESS:
      return CombinedClaimStatus.IN_PROGRESS;
    case PretaxClaimStatus.CLAIM_ADJUSTED_OVERPAID:
    case PretaxClaimStatus.CANCELLED:
    case PretaxClaimStatus.DECLINED:
    case PretaxClaimStatus.PENDING_CANCEL:
    case PretaxClaimStatus.DENIED:
    case PretaxClaimStatus.REJECTED:
      return CombinedClaimStatus.REJECTED;
    case PretaxClaimStatus.PENDING:
    case PretaxClaimStatus.PROCESSING:
    case PretaxClaimStatus.DEFAULT:
    case PretaxClaimStatus.ENTERED_NOT_REVIEWED:
    case PretaxClaimStatus.REVIEWED_PENDING_APPROVAL:
      return CombinedClaimStatus.PENDING;
    case PretaxClaimStatus.NEEDS_RECEIPT:
      return CombinedClaimStatus.NEEDS_RECEIPT;
    default:
      return CombinedClaimStatus.PENDING;
  }
};

export const displayAmountAsCurrency = ({
  displayAsAmount,
  amountToPointsRatio,
  amount = 0,
  currency,
}: {
  displayAsAmount: boolean;
  amountToPointsRatio: number;
  amount: number;
  currency: string;
}) => {
  const currency_amount = displayAsAmount
    ? amount
    : (amount * 1.0) / amountToPointsRatio;
  return convertToCurrency({ amount: currency_amount, currency });
};

export const generateClaimDropdownOption = (label: string) => {
  const [first, ...rest] = label.split(/_|\s/g);
  return `${startCase(first)}${
    rest.length > 0 ? ` ${rest.map((str) => str.toLowerCase()).join(' ')}` : ''
  }`;
};
